import { motion } from "framer-motion";
import SceneShell from "../components/SceneShell";
import CountUp from "../components/CountUp";

/**
 * Scene 03 — First reveal: 200B (Instagram) + 200B (YouTube Shorts)
 * Side-by-side count-up. Both numbers animate to 200 billion.
 */
export default function Scene03_TwoPlatforms() {
  return (
    <SceneShell variant="ink" align="center" data-testid="scene-two-platforms">
      {/* Subtle two-tone backdrop */}
      <motion.div
        className="absolute inset-y-0 left-0 w-1/2 pointer-events-none"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.0, delay: 0.2 }}
        style={{
          background:
            "radial-gradient(ellipse at center, rgba(150,193,31,0.12) 0%, transparent 60%)",
        }}
      />
      <motion.div
        className="absolute inset-y-0 right-0 w-1/2 pointer-events-none"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.0, delay: 0.4 }}
        style={{
          background:
            "radial-gradient(ellipse at center, rgba(0,222,182,0.12) 0%, transparent 60%)",
        }}
      />

      <div className="relative max-w-[1500px] mx-auto w-full">
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="kn-eyebrow mb-14 mx-auto"
        >
          The answer · revealed
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-20 items-end">
          {/* Instagram column */}
          <motion.div
            initial={{ opacity: 0, x: -32 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1.0, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
            className="text-left md:text-right md:pr-6 md:border-r md:border-white/10"
            data-testid="platform-card-instagram"
          >
            <div className="text-[11px] tracking-[0.32em] uppercase text-white/55 mb-6">
              Instagram
            </div>
            <div
              className="kn-display tnum text-[72px] sm:text-[108px] lg:text-[140px] leading-none"
              style={{ color: "#96C11F" }}
            >
              <CountUp
                from={0}
                to={200}
                duration={2.2}
                startDelay={0.6}
                suffix="B"
                data-testid="instagram-count"
              />
            </div>
            <div
              className="mt-5 text-base sm:text-lg"
              style={{ color: "rgba(255,255,255,0.7)" }}
            >
              videos watched · per day
            </div>
          </motion.div>

          {/* YouTube Shorts column */}
          <motion.div
            initial={{ opacity: 0, x: 32 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1.0, delay: 0.6, ease: [0.16, 1, 0.3, 1] }}
            className="text-left md:pl-6"
            data-testid="platform-card-youtube"
          >
            <div className="text-[11px] tracking-[0.32em] uppercase text-white/55 mb-6">
              YouTube Shorts
            </div>
            <div
              className="kn-display tnum text-[72px] sm:text-[108px] lg:text-[140px] leading-none"
              style={{ color: "#00deb6" }}
            >
              <CountUp
                from={0}
                to={200}
                duration={2.2}
                startDelay={0.9}
                suffix="B"
                data-testid="youtube-count"
              />
            </div>
            <div
              className="mt-5 text-base sm:text-lg"
              style={{ color: "rgba(255,255,255,0.7)" }}
            >
              videos watched · per day
            </div>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 3.0 }}
          className="mt-20 text-center text-sm tracking-[0.32em] uppercase text-white/45"
        >
          two platforms · same number · same day
        </motion.div>
      </div>
    </SceneShell>
  );
}
